<script setup lang="ts">
import { ref } from "vue";
import { useAuthStore } from "@/ts/stores/auth";
import { CancelationData, CancelReason, CancelConfirmation } from "@/ts/components/members";
import { useUrlSearchParams } from "@vueuse/core";

interface Props {
    id?: string;
}

defineProps<Props>();
const params = useUrlSearchParams("history");
const authStore = useAuthStore();
const step = ref(1);
const box = ref<HTMLDivElement>();
const boxHeight = ref();
const data = ref<CancelationData>({
    reasons: {
        reason: "",
        comment: "",
    },
});

if (params && params.renewal_key) {
    authStore.readUser(Array.isArray(params.renewal_key as string[]) ? params.renewal_key[0] : (params.renewal_key as string));
}

function calculateBoxHeight(height: number | undefined = undefined) {
    boxHeight.value = height ? height : box.value!.offsetHeight;
}

function nextStep(property: keyof typeof data.value, value: any) {
    (data.value as Record<string, any>)[property] = value;
    step.value++;
}

function undoRedirect() {
    window.location.href = `/lid-worden?renewal_key=${params.renewal_key}`;
}
</script>

<template>
    <section :id="id" class="flex min-h-screen items-center transition-all duration-500 ease-in-out">
        <div class="container">
            <div class="flex justify-center">
                <div class="w-full lg:w-10/12 xl:w-8/12">
                    <div ref="box" :style="boxHeight ? `height: ${boxHeight}px` : ''" class="relative flex overflow-hidden bg-white transition-all duration-500 ease-in-out">
                        <transition-group name="fade-absolute" mode="out-in">
                            <cancel-reason v-if="step === 1" @submit="nextStep('reasons', $event)" @back="undoRedirect()" @mounted="calculateBoxHeight($event)"></cancel-reason>
                            <cancel-confirmation v-if="step === 2" @mounted="calculateBoxHeight($event)"></cancel-confirmation>
                        </transition-group>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
